import { SoundCloudStoryblok } from '../types/generated-storyblok';
import SoundCloud from './Content/SoundCloud';

interface ContentBlockSoundCloudProps {
  blok: SoundCloudStoryblok;
}

export const ContentBlockSoundCloud = ({
  blok,
}: ContentBlockSoundCloudProps) => (
  <div className="mx-auto w-full max-w-lg">
    <SoundCloud trackId={blok.trackId} />
  </div>
);
